<template>
  <div class="body-div bcEE">
    <div class="shade index-3000" v-show="!isHidden" @click="hidePanel"></div>
    <div class="center-item index-3000" v-show="!isHidden">
      <div class="bcfff div p40 w-80">
        <div class="input_view">
          <div class="left f60 f-blod">{{num}}</div>
          <div class="iconfont icon-backspace-fill right f70" @touchstart="changeActive" @touchend="removeActive" @click="backspace"></div>
        </div>
        <div class="flex-container h130 f-blod f80">
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive"   data-num="1" @click="inputNum">1</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="2" @click="inputNum">2</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="3" @click="inputNum">3</div>
        </div>
        <div class="flex-container h130 f-blod f80">
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="4" @click="inputNum">4</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="5" @click="inputNum">5</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="6" @click="inputNum">6</div>
        </div>
        <div class="flex-container h130 f-blod f80">
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="7" @click="inputNum">7</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="8" @click="inputNum">8</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="9" @click="inputNum">9</div>
        </div>
        <div class="flex-container f-blod f80">
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="0" @click="inputNum">0</div>
        </div>
        <div class="span-right c007948 pt40">
          <div class="right" @click="search" @touchstart="changeActive" @touchend="removeActive">确定</div>
          <div class="mr50 right" @click="hidePanel" @touchstart="changeActive" @touchend="removeActive">取消</div>
        </div>
      </div>
    </div>

    <div class="pb40 scroll" :style="{'height':scrollHeight}" >
     <!-- <div class="bcfff mb20" style="z-index:100">
        <mp-photo-album id="album" :list="imageSrc" bindlike="like" bindclose="finish"></mp-photo-album>
        &lt;!&ndash;
              <swiper class='w-100 align-center' style="height:{{imgHeight}}px" indicator-dots="true">
                <swiper-item v-for= "(item,index) in imgSrc}}" wx:key="item">
                    <img class='img' :src='item.src}}' mode='aspectFit'                                                 @click="openImg" data-index="{{index}}" bindload="imgLoad"></img>
                </swiper-item>
              </swiper> &ndash;&gt;
      </div>-->

      <div class="swiper-container mb20"  :style="{'height':scrollHeight}" >
        <viewer class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in imageSrc">
              <img class='img' :v-gallery="['group'+index]" :src='item.src'   :data-index="index">
            </div>
        </viewer>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>


      <div v-for="(item,index) in cc"  class="mb20 w-100 over_auto h120">
        <div class="flex-parent">
          <span class="title-view">{{index==0?'原':'伴'}}<br/>{{index==0?'唱':'奏'}}</span>
          <div class="audio-view flex-wrap1">
            <VueAudio v-if="update" :theUrl="item.src" :theControlList="item.controlList"/>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-view index-2000" ref="tabView1">
      <div class="text-center" data-index="0" @click="nextPrev" @touchstart="changeActive" @touchend="removeActive">
        <div class="iconfont icon-shangyishou h40 mb5"></div>
        <div class="f23">上一首</div>
      </div>
      <div class="text-center" @click="toHome" @touchstart="changeActive" @touchend="removeActive">
        <div class="iconfont icon-home h40 mb5 f38"></div>
        <div class="f23">主页</div>
      </div>
      <div class="text-center" @click="showPanel" @touchstart="changeActive" @touchend="removeActive">
        <div class="iconfont icon-jianpankeyboard48 h40 mb5"></div>
        <div class="f23">选择</div>
      </div>
      <div class="text-center" @touchstart="changeActive" @touchend="removeActive" @click="collect">
        <div class="iconfont icon-aixin h40 mb5" :class="isCollet?'c24af08':''" ></div>
        <div class="f23" :class="isCollet?'c24af08':''">收藏</div>
      </div>
      <div class="text-center" data-index="1" @click="nextPrev" @touchstart="changeActive" @touchend="removeActive">
        <div class="iconfont icon-xiayishou h40 mb5"></div>
        <div class="f23">下一首</div>
      </div>
     <!-- <button class="text-center fenxiang-button" @touchstart="changeActive" @touchend="removeActive" open-type="share">
        <div class="iconfont icon-fenxiang1 f40 h50"></div>
        <div class="f23">分享</div>
      </button>-->

    </div>
  </div>
</template>
<script>
import vue from "vue"
import http from '@/util/http.js'
import utils from '@/util/utils.js'
import Swiper from 'swiper';
import gallery from 'img-vuer'
import '@/css/songPage.css'
import '@/css/swiper.css'
import VueAudio from '../components/VueAudio'

vue.use(gallery)

var vm = vue;
export default {
  name: "songPage",
  components: {
    VueAudio
  },
  data() {
    return {
      value:0,
      URL:"https://www.xunzhiedu.com:8080/",
      number:null,
      isHidden: true,
      num: "",
      imageSrc:[],
      audioSrc:'',
      audioContext:null,
      audio:null,
      audioIndex: null,
      isIphoneX: false,
      scrollHeight: 0,
      cataIndex:null,
      type:null,
      isCollet:false,
      windowWidth:0,
      imgHeight:500,
      update:true,
      cc:[
        {
          totalProcess:'00:00',
          totalProcessNum:0,
          currentProcess:'00:00',
          currentProcessNum:0,
          showAudio:false,
          canSlider:true,
          isMove:false,
          src:'',
          controlList: 'noDownload noVolume noMuted noSpeed onlyOnePlaying'
        },
        {
          totalProcess: '00:00',
          totalProcessNum: 0,
          currentProcess: '00:00',
          currentProcessNum: 0,
          showAudio: false,
          canSlider: true,
          isMove: false,
          src: '',
          controlList: 'noDownload noVolume noMuted noSpeed onlyOnePlaying'
        }
      ]
    }
  },
  methods: {
    toHome:function(){
      this.$router.push({
        name: 'index'
      })
    },
    showPanel: function () {
      this.num = '';
      this.isHidden = false;
    },
    hidePanel: function () {
      this.isHidden = true;
    },
    inputNum: function (e) {
      const number = this.num + e.currentTarget.dataset.num;
      if (number.length<6){
        this.num = number
      }

    },
    backspace:function(){
      let num = this.num;
      if(num && num.length>0){
        num = num.substring(0, num.length-1);
        this.num = num
      }

    },
    search: function (e) {
      let num= this.num;
      if(!num){
        this.$toast("请输入数字");
        return;
      }
      if(num==0) {
        this.$toast("请输入大于0的数字");
        return;
      }
      num = parseInt(num);
      const that = this;
      http.post('/song/getContentsList',{search: num}).then(res=>
        {
          if (res.code === 0) {
            const list = res.data;
            if(!list || list.length==0){
              that.$toast(num+'首不存在');
            }else{
              that.num = num;
              that.cataIndex = list[0].cataIndex;
              that.type = list[0].type;
              that.isColletFunc();
              that.skip();
            }
          }else{
            that.$toast('查找失败，请重试');
          }
        }
      )
    },
    skip:function(){
      let that = this;
      let imgSrc = [{
        src: that.URL + '/img/' + that.num + '.jpg'
      }]
      if (that.type == 1){
        imgSrc.push({
          src: that.URL + '/img/' + that.num + '-1.jpg'
        })
      }
      imgSrc.push({
        src: that.URL + '/img1/' + that.num + '.jpg'
      })
      if (that.type == 1) {
        imgSrc.push({
          src: that.URL + '/img1/' + that.num + '-1.jpg'
        })
      }
      this.saveBrowse();
      this.number = that.num;
      this.imageSrc = imgSrc;
      this.isHidden = true;
      that.cc[0].src = that.URL + '/audio/' + that.num + '.m4a';
      that.cc[1].src = that.URL + '/audio1/' + that.num + '.m4a';
      let arr = that.cc
    /*  if (that.audio) {
        that.audio.stop();
      }
      setTimeout(function(){
        for (let i = 0; i < arr.length; i++) {//将所有的音频置为停止状态
          that.setAudioType(i, false, true)
          that.setCurrent(i, "00:00", 0)
          that.setTotal(i, "00:00", 0)
        }

      },200)*/
      this.update = false
      this.$nextTick(() => (this.update = true))
    },
    nextPrev:function(e){
      let index = e.currentTarget.dataset.index;
      let number = parseInt(this.number);
      if(index==0){
        if(number == 1){
          return;
        }
        number--;
      }else{
        number++
      }
      this.num = number;
      this.search();
    },
    saveBrowse:function(){
      let that = this;
      http.post("/song/saveBrowse", {cataIndex: that.cataIndex});
    },
    isColletFunc:function(){
      let that = this;
      http.post("/song/isCollect", {cataIndex: that.cataIndex}).then(res=> {
        if (res.code === 0) {
          that.isCollet = res.data
        }
      })
    },
    collect:function(){
      let that = this;
      let type = 1;
      if (that.isCollet){
        type = 2;
      }
      http.post("/song/collect", {cataIndex: that.cataIndex,type: type})
        .then(res => {
          if (res.code === 0) {
            that.isCollet  = !that.isCollet
            this.$toast(res.msg)
          }
        })
    },
    // 每张图片加载完成会执行 imageload 方法
    imageLoad: function (e) {
      if(e.currentTarget.dataset.index!=0){
        return;
      }
      // 获取图片宽高比
      let ratio = e.detail.width / e.detail.height
      // 按照宽高比计算图片宽度 100% 时的高度
      let imgHeight = this.windowWidth / ratio
      // 把每一张图片对应的高度记录到 imgsHeight 数组里
      this.imgHeight = imgHeight
      console.log(imgHeight)
    },
    changeActive($event){
      $event.currentTarget.className = $event.currentTarget.className +  " c24af08";
    },
    removeActive($event){
      $event.currentTarget.className = $event.currentTarget.className.replace("c24af08","");
    }
  },
  created(){
    this.num = this.$route.query.number;
    this.cataIndex = this.$route.query.number;
    this.type = this.$route.query.type;
    this.skip();
  },
  mounted(){
    if(!this.$global.isLogin) {
      let url = window.location.href;
      let arr = url.split("code=");
      if(arr.length>1){
        this.code = arr[1].split("&")[0];
        this.$global.login(this.code);
      }
    }
    let that = this;
    that.isColletFunc();
    // const audioContext = wx.createInnerAudioContext()
    // audioContext.autoplay = true
    // audioContext.src = that.URL + '/' + this.data.searchValue + '.m4a'
    // audioContext.onPlay(function () {
    //   console.log("开始播放")
    // })

    // this.data({
    //   audioContext: audioContext
    // })

    // 判断手机是否为iphoneX
      // console.log('手机信息res'+res.model)
      that.isIphoneX = utils.isIphoneXFunc()
      let windowHeight = document.documentElement.clientHeight // 屏幕的高度
      let windowWidth = document.documentElement.clientWidth// 屏幕的高度
      that.scrollHeight =  (windowHeight - this.$refs.tabView1.offsetHeight) + 'px';
      that.windowWidth =  windowWidth;
    new Swiper ('.swiper-container', {
      loop: true,
      // 如果需要分页器
      pagination:{
        el:'.swiper-pagination',
        clickable:true,
      },
      observer:true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents:true//修改swiper的父元素时，自动初始化swiper
    })
  }
}</script>
<style scoped>
  .swiper-pagination{
    bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/songPage.vue